<template>
    <div class="labels">
        <ul ref="list" class="labels__list">
            <li v-for="(label, index) in labels" :key="index" ref="label" class="labels__label">
                <span>{{ label.label }}</span>

                <button type="button" @click.stop="emitEvent({ name: 'click', payload: label })">
                    <common-icon name="close" size="tiny"></common-icon>
                </button>
            </li>
        </ul>
        <span v-if="moreCount > 0" class="labels__more">
            {{ $t('common.microcopy.plus_x_more', { x: moreCount }) }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            labels: { type: Array, required: true },
        },

        data() {
            return {
                moreCount: 0,
            }
        },

        methods: {
            recalculateMore() {
                this.$nextTick(() => {
                    const allLabels = this.$refs.label
                    const visibleLabels = []

                    if (!Array.isArray(allLabels)) {
                        return
                    }

                    for (const label of allLabels) {
                        if (label.offsetTop === 0) {
                            visibleLabels.push(label)
                        }
                    }

                    this.moreCount = allLabels.length - visibleLabels.length
                })
            },
        },

        watch: {
            labels() {
                this.recalculateMore()
            },

            moreCount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    // Trigger recalculation again in case when text of "+ X more"
                    // causes even more labels to hide.
                    this.recalculateMore()
                }
            },
        },

        mounted() {
            this.recalculateMore()
        },
    }
</script>
